import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { SectionHeading } from '../ui/SectionHeading';
import { CalendarIcon, ArrowRightIcon } from 'lucide-react';
const news = [{
  id: '1',
  title: 'AU-UK Partnership Launches £15M Trade Initiative',
  excerpt: 'New programme aims to strengthen trade relationships and facilitate investment flows between the UK and African markets.',
  date: '2026-05-10',
  category: 'Trade & Investment'
}, {
  id: '2',
  title: 'Digital Skills Programme Reaches 5,000 Young Africans',
  excerpt: 'Comprehensive training in AI, data science, and software development empowers next generation of tech professionals.',
  date: '2026-05-08',
  category: 'Education'
}, {
  id: '3',
  title: 'Climate Finance Advisory Services Tender Closing Soon',
  excerpt: 'AU-UK seeking expert advisory services for structuring climate finance instruments and green bonds.',
  date: '2026-05-05',
  category: 'Procurement'
}];
export function NewsSection() {
  return <section className="py-20 bg-white" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4" data-id="element-167">
        <SectionHeading title="Latest News & Announcements" subtitle="Stay updated with our latest developments and initiatives" data-id="element-168" />

        <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-169">
          {news.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-170">
              <Card hover className="h-full flex flex-col" data-id="element-171">
                <div className="text-xs font-medium text-au-green mb-2" data-id="element-172">
                  {item.category}
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-173">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-4 flex-1" data-id="element-174">{item.excerpt}</p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-border" data-id="element-175">
                  <div className="flex items-center gap-1 text-sm text-gray-500" data-id="element-176">
                    <CalendarIcon size={16} data-id="element-177" />
                    <span data-id="element-178">
                      {new Date(item.date).toLocaleDateString('en-GB')}
                    </span>
                  </div>
                  <button className="flex items-center gap-1 text-au-green font-medium text-sm hover:gap-2 transition-all" data-id="element-179">
                    <span data-id="element-180">Read More</span>
                    <ArrowRightIcon size={16} data-id="element-181" />
                  </button>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}